<div class="text-center">
    <div style="display: inline-block;" *ngFor="let theme of themes">
        <span class="badge filter" [style.background]="theme.color" [class.active]="theme.isActive" (click)=onChangeTheme(theme)></span>
    </div>

    <mat-divider class="custom-divider"></mat-divider>

    <mat-expansion-panel class="custom-expansion">
        <mat-expansion-panel-header>
            <mat-panel-title class="picker-title">
                Custom
                <span *ngIf="isCustomActive()" class="custom-active-swatch" [style.background]="customPrimary"></span>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="custom-picker">
            <div class="colour-wrap">
                <div class="colour-swatch-wrap">
                    <div class="colour-swatch" [style.background]="customPrimary"></div>
                    <input id="primaryColor" type="color" [ngModel]="customPrimary" (ngModelChange)="onCustomChange($event)" class="colour-input" title="Primary colour" aria-label="Primary colour">
                </div>
            </div>

        </div>

    </mat-expansion-panel>
    <!-- Sadly most components are Iframes or white so dark mode effects very little. Switch hidden -->
    <!-- <div style="margin-top: 12px;">
        <mat-slide-toggle [checked]="isDark" (change)="onToggleDark($event)">Dark Mode</mat-slide-toggle>
    </div> -->
</div>